import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { propPanelMixin } from "../../../../lib/helpers";
import EventCardListOld from "../EventPanel/EventCardList/index";
import ReportCardListOld from "../EventPanel/ReportCardList/index";
import PluginCardList from "../EventPanel/PluginCardList/index";
let EventPanelNew = class EventPanelNew extends Vue {
  constructor() {
    super(...arguments);
    /** 如果Layout上没有event字段 监听会出问题 从card抛出一个change事件来强行刷一下卡片列表 正好在添加的是把其余的东西都折叠了 */
    this.showList = true;
    /** 存一下有没有插件 */
    this.plugins = [];
  }
  reRender() {
    this.showList = false;
    this.$nextTick(() => {
      this.showList = true;
    });
  }
  get isEmptyPluginCard() {
    return Object.keys(this.plugins).length === 0;
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-eventPanelNew"
    }, [h("a-divider", {
      "style": "margin:16px 0;"
    }), h("div", {
      "class": "ucd-eventPanelNew-addButtonBox"
    }, [h("event-card-list-old", {
      "on": {
        "change": this.reRender
      },
      "attrs": {
        "compPath": this.compPath,
        "showList": false
      }
    }), h("report-card-list-old", {
      "on": {
        "change": this.reRender
      },
      "attrs": {
        "compPath": this.compPath,
        "showList": false
      }
    })]), h("div", {
      "style": "height:16px;"
    }), this.showList ? h("div", {
      "class": "ucd-eventPanelNew-listBox"
    }, [h("event-card-list-old", {
      "attrs": {
        "compPath": this.compPath,
        "showAddButton": false
      }
    }), h("report-card-list-old", {
      "attrs": {
        "compPath": this.compPath,
        "showAddButton": false
      }
    }), h("plugin-card-list", _mergeJSXProps([{
      "attrs": {
        "compPath": this.compPath
      },
      "style": this.isEmptyPluginCard && 'margin-top:auto'
    }, {
      "on": {
        'update:plugins': e => this.plugins = e
      }
    }]))]) : null]);
  }
};
EventPanelNew = __decorate([Component({
  name: 'EventPanelNew',
  components: {
    EventCardListOld,
    ReportCardListOld,
    PluginCardList
  },
  mixins: [propPanelMixin]
})], EventPanelNew);
export { EventPanelNew };
//# sourceMappingURL=index.js.map
